import logo from './logo.png';
import './App.css';
import { useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';

function App() {
  const ref = useRef();
  const params = useParams();
  const location = useLocation();
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Belajar Ejaan Bahasa Indonesia Lebih Menyenangkan!
        </p>
        <a
          className="App-link"
          href={params?.passcode ? `jagopuebi://play/${params?.passcode}${location.search ?? ''}` : "jagopuebi://"}
          target="_blank"
          rel="noopener noreferrer"
          ref={ref}
        >
          Buka Aplikasi Jago PUEBI di <i>Smartphone</i>
        </a>



      </header>
    </div>
  );
}

export default App;
